var map = {
	"./Commant.png": "9fcf",
	"./DaiwaQ.png": "e4f4",
	"./ProduuzIT.png": "36d5",
	"./SAP.png": "df95",
	"./demo": "b177",
	"./demo.json": "b177"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c731";